import { render, staticRenderFns } from "./yearly-sold-by-sale-type.vue?vue&type=template&id=5bb82377"
import script from "./yearly-sold-by-sale-type.vue?vue&type=script&lang=js"
export * from "./yearly-sold-by-sale-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports